var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyDesigns',{attrs:{"editRoute":"designer.edit","routeParam":"id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }